'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var flxSizeBorderRadiusTiny = "0.2rem";
var flxSizeBorderRadiusSmall = "0.4rem";
var flxSizeBorderRadiusMedium = "0.8rem";
var flxSizeBorderRadiusLarge = "1.2rem";
var flxSizeBorderRadiusXLarge = "2.4rem";
var flxSpacingXxTiny = "0.2rem";
var flxSpacingXTiny = "0.4rem";
var flxSpacingTiny = "0.8rem";
var flxSpacingXSmall = "1.2rem";
var flxSpacingSmall = "1.6rem";
var flxSpacingMedium = "2.0rem";
var flxSpacingLarge = "2.4rem";
var flxSpacingXLarge = "3.2rem";
var flxSpacingXxLarge = "4.8rem";

exports.flxSizeBorderRadiusLarge = flxSizeBorderRadiusLarge;
exports.flxSizeBorderRadiusMedium = flxSizeBorderRadiusMedium;
exports.flxSizeBorderRadiusSmall = flxSizeBorderRadiusSmall;
exports.flxSizeBorderRadiusTiny = flxSizeBorderRadiusTiny;
exports.flxSizeBorderRadiusXLarge = flxSizeBorderRadiusXLarge;
exports.flxSpacingLarge = flxSpacingLarge;
exports.flxSpacingMedium = flxSpacingMedium;
exports.flxSpacingSmall = flxSpacingSmall;
exports.flxSpacingTiny = flxSpacingTiny;
exports.flxSpacingXLarge = flxSpacingXLarge;
exports.flxSpacingXSmall = flxSpacingXSmall;
exports.flxSpacingXTiny = flxSpacingXTiny;
exports.flxSpacingXxLarge = flxSpacingXxLarge;
exports.flxSpacingXxTiny = flxSpacingXxTiny;
